import {Component} from 'react'
import {connect} from "react-redux"

import conf from "../../../../../shared/conf.js"
import DefaultLayout from "../../../Layout/DefaultLayout.jsx"
import MyAccountContent from "./MyAccountContent.jsx"
import Navbar from "../../../Navbar/Navbar.jsx"

import './MyAccount.scss'

class MyAccount extends Component {
  render() {
    const {currentUser, profile, freelance} = this.props
    const isFreelanceAccount = (currentUser) && currentUser.account_type === conf.accountTypes.freelance

    const freelanceProp = profile ? profile.freelance : freelance

    if(!isFreelanceAccount) {
      return <MyAccountContent {...this.props} />
    }

    return(
      <DefaultLayout navbar={this.props.navbar ? <Navbar locked={true}/> : null}>
        <div className="page-background print-no-color">
          <div className="container py-5">
            <MyAccountContent {...this.props} freelance={freelanceProp}/>
          </div>
        </div>
      </DefaultLayout>
    )
  }
}

export default connect((state) => {
  return {currentUser: state?.currentUser.user ?? {}}
})(MyAccount)
